export default __webpack_public_path__ + "static/media/foreign-language-bg.1fbd4101.webp";